import type { User } from '@core/api/user';
import type { ActorType } from '@core/enum/actorType';
import type { AuditAction } from '@core/enum/auditAction';
import type { BaseEntity } from '@core/interfaces';
import axiosInstance from '@core/utils/axiosInstance';

export interface AuditLogEntry extends BaseEntity {
  action: AuditAction;
  subjectType: string;
  subjectId: number | null;
  actor: Pick<User, 'id' | 'firstName' | 'lastName'> | null;
  actorType: ActorType;
  changes: Record<string, { old: unknown; new: unknown }> | null;
  metadata: Record<string, unknown> | null;
}

export interface AuditLogFilters {
  action?: AuditAction;
  subjectType?: string;
  subjectId?: number;
  actorId?: number;
  dateFrom?: string;
  dateTo?: string;
  q?: string;
}

export interface AuditLogResponse {
  items: AuditLogEntry[];
  total: number;
  page: number;
  limit: number;
}

export interface AuditLogQuery extends AuditLogFilters {
  page?: number;
  limit?: number;
}

export async function getAuditLogs(
  query: AuditLogQuery = {}
): Promise<AuditLogResponse> {
  const params = new URLSearchParams();

  if (query.page != null) params.set('page', String(query.page));
  if (query.limit != null) params.set('limit', String(query.limit));
  if (query.action) params.set('action', query.action);
  if (query.subjectType) params.set('subjectType', query.subjectType);
  if (query.subjectId != null) params.set('subjectId', String(query.subjectId));
  if (query.actorId != null) params.set('actorId', String(query.actorId));
  if (query.dateFrom) params.set('dateFrom', query.dateFrom);
  if (query.dateTo) params.set('dateTo', query.dateTo);
  if (query.q) params.set('q', query.q);

  const qs = params.toString();
  const url = qs ? `/audit-log?${qs}` : '/audit-log';
  const { data } = await axiosInstance.get<AuditLogResponse>(url);
  return data;
}
